<template>
  <div class="DownloadContents">
    <div class="DownloadContents-icon" />
    <p>まずはダウンロード！</p>
    <div class="DownloadContents-ios" @click="onClickIosButton" />
    <div class="DownloadContents-android" @click="onClickAndroidButton" />
  </div>
</template>

 <script>
export default {
  name: "DownloadContents",
  methods: {
    onClickIosButton() {
      window.open("https://apps.apple.com/app/id1575315710", "_blank");
    },
    onClickAndroidButton() {
      window.open("https://play.google.com/store/apps/details?id=net.cosmojapan.chirioil", "_blank");
    },
  },
};
</script>

<style scoped>
.DownloadContents {
  background-image: url("../assets/images/DownloadContents_download.png");
  margin: 0 auto;
  display: flex;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  margin-top: 3%;
  margin-bottom: 5%;
  width: 70vw;
  height: 18.7vw;
}
p {
  color: #383838;
  font-size: 2.5vw;
  margin-top: 3%;
  margin-left: 50%;
  font-family: Arial, Helvetica, sans-serif;
}
.DownloadContents-icon {
  background-image: url("../assets/images/appicon.png");
  width: 17vw;
  height: 17vw;
  position: absolute;
  left: 5%;
  background-size: contain;
  background-repeat: no-repeat;
  margin-top: 1%;
  margin-right: 10%;
}
.DownloadContents-ios {
  background-image: url("../assets/images/apple.png");
  width: 16.75vw;
  height: 5.17vw;
  position: absolute;
  top: 35%;
  left: 40%;
  background-size: contain;
  background-repeat: no-repeat;
  margin-top: 2%;
  margin-right: 5%;
}
.DownloadContents-android {
  background-image: url("../assets/images/google.png");
  width: 16.75vw;
  height: 5.17vw;
  position: absolute;
  top: 35%;
  left: 70%;
  background-size: contain;
  background-repeat: no-repeat;
  margin-top: 2%;
}
</style>
